var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeftLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.375 13.002a.853.853 0 0 0-.852-.852H6.463l4.385-4.527a.85.85 0 0 0-.03-1.206.852.852 0 0 0-1.206.031L3.86 12.415a.853.853 0 0 0 0 1.174l5.753 5.966a.853.853 0 0 0 1.236-1.174l-4.386-4.527h15.061c.47 0 .852-.382.852-.852Z",
  fill: "#1A1A1A"
})));
export default SvgArrowLeftLarge;